<template>
  <v-container>
    <v-row class="align-center justify-end">
      <v-btn
          color="primary"
          dark
          class="mb-2 text-body-2"
          @click="goToCreateSlider"
      >{{ addSlide }}
      </v-btn>
    </v-row>
    <v-data-table
        v-if="courseMenu && courseMenu.length > 0"
        :headers="headers"
        :items="courseMenu"
        class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.course_child="{ item }">
        <ul>
          <li
              v-for="data_list in item.course_child"
              :key="data_list.id"
              class="mt-2"
          >
            {{ data_list.title }}
          </li>
        </ul>
      </template>
    </v-data-table>
    <CreateCourseMenuDialog
        :courseId="currentCourseId"
        :dialog="showCreateSliderDialog"
        @onClickOutside="showCreateSliderDialog = false"
        @closePopup="closePopup"
    ></CreateCourseMenuDialog>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import {
  GET_HOME_PAGE_CONF,
  GET_COURSE_MENU_CONF,
  SAVE_CONF,
  DELETE_COURSE
} from "@/store/setting.module";
import CreateCourseMenuDialog from "@/views/dialogs/create-course-menu-dialog.vue";
import {SET_BREADCRUMB} from "@/store/breadcrumbs.module";

export default {
  data() {
    return {
      headers: [
        {text: "STT", value: "id"},
        {text: "Tên", value: "title"},
        {text: "Khóa học", value: "course_child", sortable: false},
        {text: "Sửa/Xóa", value: "actions", sortable: false}
      ],
      editedIndex: -1,
      cardImg: "",
      editedItem: {
        word: "",
        example: "",
        translate: "",
        note: "",
        cardImg: ""
      },
      defaultItem: {
        word: "",
        example: "",
        transalte: "",
        note: "",
        images: {}
      },
      image: {},
      currentCourseId: 0,
      showCreateSliderDialog: false,
      addSlide: "Thêm Khóa Học",
    };
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: "Cấu hình Trang chủ", titledad: 'Cấu hình'}]);
  },
  computed: {
    ...mapGetters({
      courseMenu: "courseMenu"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New card" : "Edit card";
    },
    submitTypeName() {
      return this.editedIndex === -1 ? "Save" : "Update";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  components: {
    CreateCourseMenuDialog
  },
  methods: {
    goToCreateSlider() {
      this.currentCourseId = this.courseMenu ? this.courseMenu.length : 0;
      this.showCreateSliderDialog = true;
    },
    editItem(item) {
      this.$store.commit(GET_COURSE_MENU_CONF, item.id);
      this.showCreateSliderDialog = true;
    },
    async deleteItem(item) {
      this.$store.commit(DELETE_COURSE, item);
      let data = {
        key: "course_menu",
        value: this.courseMenu
      };
      confirm("Are you sure you want to delete this item?") &&
      (await this.$store.dispatch(SAVE_CONF, data));
    },

    close() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closePopup() {
      this.reloadConfig();
      this.showCreateSliderDialog = false;
    },
    reloadConfig() {
      this.$store.dispatch(GET_HOME_PAGE_CONF);
    }
  }
};
</script>

<style lang="scss"></style>
